import React, { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { PatientInfo } from './PatientInfo';
import { PhysicianDocumentationForm } from './PhysicianDocumentationForm';
import Button from '@mui/material/Button';
import { ArrowBack, LabelOutlined } from '@mui/icons-material';
import { Grid, Tab, Tabs } from '@mui/material';
import { Labels } from "~/components/dashboard/PatientRow/Labels";
import { useLabelsQuery } from "~/hooks/useLabelsQuery";
import { PatientReportBillingEligibility } from "~/components/BillingEligibility/PatientReportBillingEligibility";
import { useNavigate } from "react-router";
import dayjs from "dayjs";
import StickyNotes from "~/components/patientReports/StickyNotes";
// import { PatientReportFollowUpDate } from '../BillingEligibility/PatientHubDatePickers/PatientReportFollowUpDate';
import { useTasksForPatient } from '~/api/tasks/getTasksForPatient';
import { useGetPatientTimeline } from '~/api/timeline/getPatientTimeline';
import { PatientHubTasks } from '../patientHubTasks/PatientHubTasks';
import { PatientTimeline } from '../patientTimeline/PatientTimeline';
export const PatientReportPane = (props) => {
    const { patient, patientReport, primaryPatient, didTalk, timeSpentRpm, timeSpentCcm, notes, supervisingProviderName, clinicSupervisingProviderName, initialSensorReviewText } = props;
    const { personalInfo, id, dob } = patient;
    const [noConsentOptionsDisabled, setNoConsentOptionsDisabled] = useState((!patient.rpmConsent && !patient.ccmConsent && !patient.cgmConsent));
    const { data } = useTasksForPatient({ patientId: patient.id });
    const tasks = data?.tasks || [];
    const [tasksDueText, setTasksDueText] = useState('TASKS');
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [draftSensorReview, setDraftSensorReview] = useState(initialSensorReviewText);
    useEffect(() => {
        const dueCount = tasks.filter((task) => {
            const today = new Date();
            today.setHours(23, 59, 59, 999); // end of today so "due today" is included
            return (task.dueDate != null &&
                new Date(task.dueDate) <= today &&
                task.completedAt == null);
        }).length;
        if (dueCount !== 0) {
            setTasksDueText('TASKS (' + dueCount + ')');
        }
    }, [tasks]);
    const currentLabelsPage = 1;
    const navigate = useNavigate();
    const { data: timelineData } = useGetPatientTimeline({ patientId: patient.id });
    const timelineActivities = timelineData?.timelineActivities ?? [];
    const handleGoBack = () => {
        navigate(-1);
    };
    const queryClient = useQueryClient();
    const { query: labelsQuery } = useLabelsQuery({ currentLabelsPage });
    const onBillingEligibilityChange = (cgmConsent, rpmConsent, dataConsent, ccmConsent) => {
        if (rpmConsent === '1' || cgmConsent === '1' || ccmConsent === '1') {
            primaryPatient.rpmConsent = true;
            primaryPatient.cgmConsent = true;
            primaryPatient.ccmConsent = true;
            primaryPatient.rpmConsentedAt = '2024';
            setNoConsentOptionsDisabled(false);
            // patient.rpmConsent = true;
            // patient.cgmConsent = true;
            // patient.rpmConsentedAt = '2024';
        }
        else {
            primaryPatient.rpmConsent = false;
            primaryPatient.cgmConsent = false;
            primaryPatient.ccmConsent = false;
            primaryPatient.rpmConsentedAt = '';
            setNoConsentOptionsDisabled(true);
            // patient.rpmConsent = false;
            // patient.cgmConsent = false;
            // patient.rpmConsentedAt = '';
        }
        if (dataConsent === '1') {
            primaryPatient.dataConsent = true;
            primaryPatient.dataConsentedAt = '2024';
            // patient.dataConsent = true;
            // patient.dataConsentedAt = '2024';
        }
        else {
            primaryPatient.dataConsent = false;
            primaryPatient.dataConsentedAt = '';
            // patient.dataConsent = false;
            // patient.dataConsentedAt = '';
        }
        if (patientReport) {
            queryClient.invalidateQueries(['patient_report', patientReport.id]);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "relative w-full flex items-center justify-center" },
            React.createElement("div", { className: "absolute left-0" },
                React.createElement(Button, { style: { width: 120 }, variant: "contained", color: "inherit", size: "large", startIcon: React.createElement(ArrowBack, null), onClick: handleGoBack }, "BACK")),
            React.createElement("div", { className: "text-center" },
                React.createElement("div", { style: { color: 'black', fontSize: 26, fontFamily: 'Barlow', fontWeight: 500 } },
                    personalInfo.firstname,
                    " ",
                    personalInfo.lastname),
                React.createElement("div", { style: { color: 'black', fontSize: 16, fontFamily: 'Barlow', fontWeight: 600 } }, dayjs(patient.dob).format('MM/DD/YYYY'))),
            React.createElement("div", { className: "absolute right-0", style: {
                    marginRight: '120px',
                    width: 'clamp(100px, 8vw, 200px)',
                    height: 80,
                    zIndex: 10
                } },
                React.createElement(StickyNotes, { patientId: patient.id }))),
        React.createElement("br", null),
        React.createElement("div", { style: { width: '100%', height: '1px', border: '1px rgba(0, 0, 0, 0.12) solid' } }),
        React.createElement(Tabs, { value: selectedIndex, color: '#2C78EB', sx: {
                minHeight: '0px',
                height: '35px',
                marginBottom: '10px', '.Mui-selected': {
                    color: '#2C78EB',
                }
            } },
            React.createElement(Tab, { id: '0', onClick: () => setSelectedIndex(0), label: 'PATIENT OVERVIEW', value: 0, className: "inline-block padding-text", key: 0, sx: { fontWeight: 'bold', minHeight: '0px', height: '35px', opacity: '1', color: selectedIndex === 0 ? '#2C78EB' : '#00000099' } }),
            React.createElement(Tab, { id: '1', onClick: () => setSelectedIndex(1), label: tasksDueText, value: 1, className: "inline-block padding-text", key: 1, sx: { fontWeight: 'bold', minHeight: '0px', height: '35px', opacity: '1', color: selectedIndex === 1 ? '#2C78EB' : '#00000099' } }),
            React.createElement(Tab, { id: '2', onClick: () => setSelectedIndex(2), label: 'TIMELINE', value: 2, className: "inline-block padding-text", key: 2, sx: { fontWeight: 'bold', minHeight: '0px', height: '35px', opacity: '1', color: selectedIndex === 2 ? '#2C78EB' : '#00000099' } })),
        selectedIndex === 0 &&
            React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement(Grid, { container: true, spacing: 1, alignItems: "stretch" },
                        React.createElement(Grid, { item: true, sm: 7, style: { paddingLeft: '5px', paddingRight: '5px', margin: '0px', fontSize: 'small', paddingTop: '5px', paddingBottom: '16px' } },
                            React.createElement("div", { className: 'rounded bg-white pl-4 pt-4 pb-4 space-y-4 block justify-start h-full' },
                                React.createElement("div", { className: "h-8 justify-start items-center gap-1 inline-flex w-full" },
                                    React.createElement(Grid, { container: true, spacing: 1 },
                                        React.createElement(Grid, { item: true, sm: 5, style: { alignContent: 'center' } },
                                            React.createElement("div", { style: { color: 'rgba(0, 0, 0, 0.56)', fontSize: 12, fontFamily: 'Barlow', fontWeight: '400' } },
                                                React.createElement(LabelOutlined, { style: { height: '15px', width: '15px', marginRight: '5px' } }),
                                                "Labels")),
                                        React.createElement(Grid, { item: true, sm: 7 }, (labelsQuery.isSuccess) && (React.createElement("div", { style: { display: 'flex' } },
                                            React.createElement(Labels, { patient: patient, availableLabels: labelsQuery.data?.labels, labelUpdated: (label) => console.log(label), isDashboard: false })))))),
                                React.createElement(PatientInfo, { containerClassName: "", dob: dob, email: personalInfo.patientEmail, phone: personalInfo.phone, id: id, primaryInsurance: patient['primaryInsurance'], secondaryInsurance: patient['secondaryInsurance'], mrn: patient['mrn'], diagnosis: patient['diagnosisCode'], secondaryDiagnosis: patient['secondaryDiagnosisCode'], supervisingProviderName: supervisingProviderName, clinicSupervisingProviderName: clinicSupervisingProviderName, patient: patient }))),
                        React.createElement(Grid, { item: true, sm: 5, spacing: 1, container: true, direction: "column", className: 'float-right', style: { paddingLeft: '5px', paddingRight: '5px', paddingTop: '5px', paddingBottom: '16px' } },
                            React.createElement(Grid, { item: true },
                                React.createElement(PatientReportBillingEligibility, { patient: primaryPatient, containerClassName: "rounded bg-white p-4 text-center space-y-4 block w-full", onSave: onBillingEligibilityChange, didTalk: didTalk, timeSpentRpm: timeSpentRpm, timeSpentCcm: timeSpentCcm }))))),
                React.createElement(PhysicianDocumentationForm, { patient: primaryPatient, patientReport: patientReport, noConsentOptionsDisabled: noConsentOptionsDisabled, notes: notes, initialSensorReviewText: initialSensorReviewText, draftSensorReview: draftSensorReview, onSensorReviewChange: setDraftSensorReview })),
        selectedIndex === 1 &&
            React.createElement(React.Fragment, null,
                React.createElement(PatientHubTasks, { tasks: tasks, patientId: patient.id })),
        selectedIndex === 2 &&
            React.createElement(React.Fragment, null,
                React.createElement(PatientTimeline, { activites: timelineActivities }))));
};
